// Grid dimensions
export const COLS = 80;
export const ROWS = 50;

// Win condition
export const TARGET = 0.80;
export const LEVELS_PER_WORLD = 4;
export const TOTAL_LEVELS = 20; // 5 worlds × 4 levels

// Tile states
export const T_VOID = 0 as const;
export const T_LAND = 1 as const;
export const T_TRAIL = 2 as const;

export type Tile = typeof T_VOID | typeof T_LAND | typeof T_TRAIL;

// Game tick rate
export const TICK_HZ = 30;
export const STEP_MS = 1000 / TICK_HZ;

// Combo
export const COMBO_WINDOW_TICKS = 4 * TICK_HZ; // 4 seconds
export const COMBO_MAX = 8;

// Power-ups
export const FREEZE_DURATION_TICKS = 5 * TICK_HZ;
export const SLOWMO_DURATION_TICKS = 6 * TICK_HZ;
export const DASH_DURATION_TICKS = 2 * TICK_HZ;
export const POWERUP_DROP_CHANCE = 0.30;
export const POWERUP_MIN_CLAIMED = 30; // min cells captured to consider drop
export const POWERUP_LIFE_MS = 12000;
export const PERFECT_CLEAR_BONUS = 5000;
export const BOSS_KILL_BONUS = 5000;
/**
 * Threshold for a level to count as "mastered" — claim percentage at
 * which the per-level bonus fires AND `runPerfectClears` increments
 * (which gates the all-perfect speedrun category).
 *
 * Used to be 0.995 (99.5%) but that's effectively unreachable in
 * practice — the player's trail and grid obstacles consume cells, so
 * claiming truly-everything is mechanically impossible. 0.95 is the
 * actual bar skilled play can hit on a clean level: a real achievement
 * without being a fantasy. Tweak if real-play data shows it's hit too
 * often (raise it) or never (lower it).
 */
export const MASTERED_CLEAR_THRESHOLD = 0.95;

// Player
export const RESPAWN_INVULN_TICKS = 90;
export const LEVEL_START_INVULN_TICKS = 60;

// Boss enclosure threshold (cell count)
export const BOSS_ENCLOSE_THRESHOLD = 80;
